import { Vector3 } from 'three';
import { Point3D } from '../../../team-apis/otterdam/answers/shape-typings';
import { Location } from '../../task-data/sensor-location';
import { getSensorDirection } from '../../toolbars/measure-toolbar/angle-utils';
import { pointToVector } from '../../utils/point-cloud-utils';
import { addPoints } from '../../utils/point-utils';
import { CameraType } from './switchable-camera';

export const DEFAULT_CAMERA_OFFSET: Point3D = [-12, -12, 20];

export function getPositionWithSensor(location: Location) {
  const cameraPosition = new Vector3(...getSensorDirection(location.rotation));
  cameraPosition.normalize().negate().multiplyScalar(15);

  const position = cameraPosition
    .add(pointToVector(location.position))
    .toArray();
  position[2] += 6;

  return position;
}

export function getPositionFromBoundingSphere(
  type: CameraType,
  target: Point3D,
) {
  let position: Point3D;
  if (type === 'perspective') {
    position = addPoints(target, DEFAULT_CAMERA_OFFSET);
  } else {
    const distanceToTarget = Math.hypot(...DEFAULT_CAMERA_OFFSET);
    position = addPoints(target, [0, 0, distanceToTarget]);
  }
  return position;
}
